import React, { useContext } from "react";
import { Bell } from "lucide-react";
import "./Header.css";
import { UserContext } from "./UserContext";

const Header = ({ title = "Courses" }) => {
  const { userInfo } = useContext(UserContext);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://via.placeholder.com/150?text=No+Avatar";
  };

  return (
    <div className="header-container">
      <h1 className="header-title">{title}</h1>
      <div className="header-right">
        <div className="header-notification">
          <Bell className="header-notification-icon" size={24} />
          <div className="header-badge"></div>
        </div>
        <div className="header-user">
          <div className="header-avatar">
            <img
              src={
                userInfo?.avatar ||
                "https://via.placeholder.com/150?text=No+Avatar"
              }
              alt="User Avatar"
              onError={handleImageError}
            />
          </div>
          <span className="header-username">
            {userInfo?.firstname} {userInfo?.lastname}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Header;
